import { create } from "zustand";
import { GridPaginationModel, GridSortModel } from "@mui/x-data-grid";
import { PostModel } from "common/models/BaseModel";
import { IFineGridFilter, IFineReportsFilter } from "../api/types";

export interface FineStore {
  postModel: PostModel<IFineGridFilter>;
  handleFiltering: (filterModel: IFineGridFilter) => void;
  handlePagination: (pageModel: GridPaginationModel) => void;

  // fineCollectionPostModel: PostModel<IFineGridFilter>;
  // fineCollectionHandleFiltering: (filterModel: IFineGridFilter) => void;
  // fineCollectionHandlePagination: (pageModel: GridPaginationModel) => void;

  handleSorting: (sortModel: GridSortModel) => void;
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  reportsCountModel: IFineReportsFilter;
  handleReportsCountFiltering: (filterModel: IFineReportsFilter) => void;
}

const useFineStore = create<FineStore>()((set) => ({
  postModel: {
    pagingModel: {
      page: 0,
      pageSize: 100,
    },
    filterModel: {
      materialAccessionNoID: null,
      accessionNoValue: null,
      memberID: null,
      memberCodeValue: null,
      fromDate: null,
      toDate: null,
      admissionYearID: null,
      departmentID: null,
      instituteID: null,
      materialTypeID: null,
      memberDepartmentID: null,
      memberInstituteID: null,
      memberTypeID: null,
      amountFilterType: null,
      waivedAmountType: null,
      waivedAmount: null,
      receivedAmountType: null,
      receivedAmount: null,
      outstandingAmountType: null,
      outstandingAmount: null,
    },
  },
  reportsCountModel: {
    materialAccessionNoID: null,
    accessionNoValue: null,
    memberID: null,
    memberCodeValue: null,
    fromDate: null,
    toDate: null,
    admissionYearID: null,
    departmentID: null,
    instituteID: null,
    materialTypeID: null,
    memberDepartmentID: null,
    memberInstituteID: null,
    memberTypeID: null,
    reportType: null,
    amountFilterType: null,
    waivedAmountType: null,
    waivedAmount: null,
    receivedAmountType: null,
    receivedAmount: null,
    outstandingAmountType: null,
    outstandingAmount: null,
  },
  handlePagination: (pageModel: GridPaginationModel) =>
    set((state) => ({
      postModel: { ...state.postModel, pagingModel: { ...pageModel } },
    })),
  handleFiltering: (filterModel: IFineGridFilter) =>
    set((state) => ({
      postModel: { ...state.postModel, filterModel: { ...filterModel } },
    })),
  handleSorting: (sortModel: GridSortModel) =>
    set((state) => ({
      postModel: { ...state.postModel, sortModel: [...sortModel] },
    })),
  isOpen: false,
  setOpen: (data: boolean) => set({ isOpen: data }),
  handleReportsCountFiltering: (reportsCountModel: IFineReportsFilter) =>
    set(() => ({ reportsCountModel: { ...reportsCountModel } })),
}));

export default useFineStore;
